import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling, {
  type MutationError
} from '@/hooks/useMutationWithErrorsHandling'
import { parseAvailabilitySlots } from '@/modules/availabilityManagement'
import { getValue } from '@/utils/get-value'

import type { RoomFormPayload } from '../constants/room-payload'

const useAddRoom = (options?: {
  onSuccess?: ({
    response,
    variables
  }: {
    response: { id: string }
    variables: RoomFormPayload
  }) => void
  onError?: ({
    errors,
    variables
  }: {
    errors: MutationError<RoomFormPayload, unknown>
    variables: RoomFormPayload
  }) => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: RoomFormPayload) =>
      httpService.panel.panelRoomsCreate({
        name: data.name,
        room_type: data.type,
        capacity: data.capacity,
        special_equipment: data.specialEquipment,
        preferred_courses: (data.preferredCourses ?? []).map(getValue),
        preferred_users: (data.preferredUsers ?? []).map(getValue),
        preferred_classes: (data.preferredClasses ?? []).map(getValue),
        availability: {
          monday: parseAvailabilitySlots(data.availability?.monday ?? []),
          tuesday: parseAvailabilitySlots(data.availability?.tuesday ?? []),
          wednesday: parseAvailabilitySlots(data.availability?.wednesday ?? []),
          thursday: parseAvailabilitySlots(data.availability?.thursday ?? []),
          friday: parseAvailabilitySlots(data.availability?.friday ?? []),
          saturday: parseAvailabilitySlots(data.availability?.saturday ?? []),
          sunday: parseAvailabilitySlots(data.availability?.sunday ?? [])
        }
      }),
    onSuccess: (response, variables) =>
      options?.onSuccess?.({ response, variables }),
    onError: (errors, variables) => {
      options?.onError?.({ errors, variables })
    }
  })

export default useAddRoom
